import { Box, Text } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { Dropdown } from '../Dropdown';
import { SingleSpanTable } from '../SingleSpanTable';
import { Tooltip } from '../Tooltip';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon } from '../utils';
import { DLVCaption } from './DLVCaption';
import { getDlvMatch } from './DLVUtils';
export const DLVSuccessfulResult = ({ dlvResult, jobStatus, dlvSubmittedData }) => {
    const { dropdownHasWarnings, dropdownHasRejections, dropdownItems } = useMemo(() => {
        const licenseNumberIsMatch = getDlvMatch(dlvResult, 'licenseNumber');
        const lastNameIsMatch = getDlvMatch(dlvResult, 'lastName');
        const birthDateIsMatch = getDlvMatch(dlvResult, 'birthDate');
        const expirationDateIsMatch = getDlvMatch(dlvResult, 'expirationDate');
        const stateIsMatch = getDlvMatch(dlvResult, 'state');
        const dropdownItemsWithoutIcons = [
            {
                text: 'License Number',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: !!licenseNumberIsMatch,
                available: true,
                hasErrorOrWarning: {
                    hasError: !licenseNumberIsMatch,
                    hasWarning: false
                },
                submittedData: dlvSubmittedData.id
            },
            {
                text: 'Last Name',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: !!lastNameIsMatch,
                available: true,
                hasErrorOrWarning: {
                    hasError: !lastNameIsMatch,
                    hasWarning: false
                },
                submittedData: dlvSubmittedData.lastName
            },
            {
                text: 'Birth Date',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: !!birthDateIsMatch,
                available: true,
                hasErrorOrWarning: {
                    hasError: !birthDateIsMatch,
                    hasWarning: false
                },
                submittedData: dlvSubmittedData.birthDate
            },
            {
                text: 'Expiration Date',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: expirationDateIsMatch,
                available: dlvResult.source === 'governmental',
                hasErrorOrWarning: {
                    hasError: expirationDateIsMatch === false,
                    hasWarning: false
                },
                submittedData: dlvSubmittedData.expirationDate
            }
        ];
        if (dlvResult.source === 'governmental') {
            dropdownItemsWithoutIcons.push({
                text: 'State',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: !!stateIsMatch,
                available: true,
                hasErrorOrWarning: {
                    hasError: !stateIsMatch,
                    hasWarning: false
                },
                submittedData: dlvSubmittedData.state
            });
        }
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [dlvResult, dlvSubmittedData]);
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: dropdownHasRejections, dropdownHasWarnings: dropdownHasWarnings, parentJobStatus: jobStatus }), title: "DLV" },
        React.createElement(Box, null,
            React.createElement(DLVCaption, null),
            React.createElement(SingleSpanTable, { items: dropdownItems.map((dropdownItem) => {
                    return {
                        label: dropdownItem.text,
                        value: dropdownItem.submittedData,
                        statusIcon: dropdownItem.statusIcon
                    };
                }), numColumns: 3 }),
            React.createElement(Box, { display: "flex", style: { gap: '20px', alignItems: 'center' } },
                React.createElement(Text, null, "Source:"),
                React.createElement(Text, { style: { fontWeight: '600' } }, dlvResult.source === 'nonGovernmental'
                    ? 'non-governmental'
                    : dlvResult.source),
                React.createElement(Tooltip, null, "Indicates if the response is from a government issuing authority or a proprietary data source.")))));
};
